import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filter'
})
export class FilterPipe implements PipeTransform {

  transform(items: any[], searchText: string, key?: string): any[] {
    if (!items) { return []; };
    if (!searchText) { return items; };
    searchText = searchText.toLowerCase();
    if (key) {
      return items.filter(it => {
        return it[key].toLowerCase().includes(searchText);
      });
    } else {
      return items.filter(it => {
        return it.toLowerCase().includes(searchText);
      });
    }
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/emr-webapp/src/app/core/pipes/filter.pipe.ts